module.exports = __webpack_public_path__ + "static/WeeklySessionPlan-ecd6e7d44345450f498525a31cfdda4c.pdf";